import Layout from "@/layout";
export default {
  path: "System",
  component: () => import('@/views/AppMain/index'),
  name: "System",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "系统管理",
    keepAlive: false,
    icon: "1026",
    activeIcon: "1025"
    // activeMenu: '/HeadOfficeManagement/BasicDataManage/BasicData'
  },
  children: [
    {
      hidden: false,
      path: "OrganizationalStructureManagement",
      component: () => import('@/views/AppMain/index'),
      name: "OrganizationalStructureManagement",
      alwaysShow: true,
      meta: {
        title: "组织架构管理",
        keepAlive: false,
      },
      children:[
        {
            hidden: false,
            path: "CompanyManagement",
            component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/CompanyManagement"),
            name: "CompanyManagement",
            meta: {
              title: "公司管理",
              keepAlive: false,
            },
        },
        {
            hidden: false,
            path: "DepartmentManagement",
            component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/DepartmentManagement"),
            name: "DepartmentManagement",
            meta: {
              title: "部门管理",
              keepAlive: false,
            },
        },
        {
            hidden: false,
            path: "PostManagement",
            component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/PostManagement"),
            name: "PostManagement",
            meta: {
              title: "岗位管理",
              keepAlive: false,
            },
        },
        {
            hidden: false,
            path: "RoleManagement",
            component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/RoleManagement"),
            name: "RoleManagement",
            meta: {
              title: "角色管理",
              keepAlive: false,
            },
        },
        {
            hidden: false,
            path: "UserManagement",
            component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/UserManagement"),
            name: "UserManagement",
            meta: {
              title: "用户管理",
              keepAlive: false,
            },
        },
        {
          hidden: true,
          path: "CompanyManagementAdd",
          component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/CompanyManagementAdd"),
          name: "CompanyManagementAdd",
          meta: {
            title: "公司新增",
            keepAlive: false,
          },
      },
      {
        hidden: true,
        path: "DepartmentManagementAdd",
        component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/DepartmentManagementAdd"),
        name: "DepartmentManagementAdd",
        meta: {
          title: "部门新增",
          keepAlive: false,
        },
    },
    {
      hidden: true,
      path: "UserManagementAdd",
      component: () => import("@/views/HeadOfficeManagement/System/OrganizationalStructureManagement/UserManagementAdd"),
      name: "UserManagementAdd",
      meta: {
        title: "用户新增",
        keepAlive: false,
      },
  },
      ]
    },
    // {
    //   hidden: false,
    //   path: "MerchantNumberManagement",
    //   component: () => import("@/views/HeadOfficeManagement/System/MerchantNumberManagement"),
    //   name: "MerchantNumberManagement",
    //   meta: {
    //     title: "商户号管理",
    //     keepAlive: false,
    //   },
    // },
    {
      hidden: true,
      path: "DataDictionaryList",
      component: () => import("@/views/HeadOfficeManagement/System/DataDictionaryList"),
      name: "DataDictionaryList",
      meta: {
        title: "数据字典列表",
        keepAlive: false,
      },
    },
    {
      hidden: true,
      path: "CityData",
      component: () => import("@/views/HeadOfficeManagement/System/CityData"),
      name: "CityData",
      meta: {
        title: "城市数据",
        keepAlive: false,
      },
    },
    // {
    //   hidden: false,
    //   path: "MenuManagement",
    //   component: () => import("@/views/HeadOfficeManagement/System/MenuManagement"),
    //   name: "MenuManagement",
    //   meta: {
    //     title: "菜单管理",
    //     keepAlive: false,
    //   },
    // },
    {
      hidden: true,
      path: "setUp",
      component: () => import("@/views/HeadOfficeManagement/System/setUp"),
      name: "setUp",
      meta: {
        title: "设置",
        keepAlive: false,
      },
    },
  ]
};
